import React from 'react';

export const CheckIcon = () => (
  <svg width={18} style={{ verticalAlign: 'middle' }} viewBox="0 0 14 14">
    <circle cx="7" cy="7" r="6" stroke="none" strokeWidth="2" fill="#f4f4f8" />

    <circle cx="7" cy="7" r="2" stroke="#333" strokeWidth="1" fill="none" />
  </svg>
);
